import { PhotoCamera } from '@material-ui/icons';
import { Validation } from './CommonData';

export const FormInputsData = [
  {
    groupLabel: 'Company Data',
    groupLabelClass: 'fieldset-label',
    key: 'company',
    groupClass: 'form-fieldset',
    inputs: [
      {
        label: 'Company Logo',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'avatar',
        placeholder: '',
        hide: false,
        formControlClass: 'input-form-control file-upload-control',
        type: 'file',
        fieldClass: 'input-file-button',
        id: 'company-avatar-upload',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box file-upload-element',
        icon: PhotoCamera,
        accept: 'image/*',
      },
      {
        label: 'Company Name',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'company_name',
        name: 'company_name',
        placeholder: 'Company Name',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        min: 3,
        max: 100,
        errors: [{ type: 'required', message: 'Please enter company name' }],
      },
      {
        label: 'Primary Email',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'email',
        name: 'primary_email',
        placeholder: 'Primary Email',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        pattern: Validation.email,
        min: 3,
        max: 100,
        errors: [
          { type: 'required', message: 'Please enter a primary email' },
          { type: 'pattern', message: 'Please enter a valid email' },
        ],
      },
      {
        label: 'Phone Number',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'phone',
        name: 'phone',
        placeholder: 'Phone Number',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        pattern: Validation.numberAndPlus,
        min: 3,
        max: 100,
        errors: [
          { type: 'required', message: 'Please enter the phone number' },
          { type: 'pattern', message: 'Please enter a valid phone number' },
        ],
      },
      {
        label: 'Website',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'website',
        name: 'website',
        placeholder: 'Website',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        pattern: Validation.website,
        min: 3,
        max: 100,
        errors: [
          { type: 'required', message: 'Please enter the company website url' },
          { type: 'pattern', message: 'Please enter a valid url' },
        ],
      },
      {
        label: 'LinkedIn',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'linkedin',
        name: 'linkedin',
        placeholder: 'LinkedIn',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        pattern: Validation.website,
        min: 3,
        max: 100,
        errors: [
          { type: 'required', message: 'Please enter the linkedin profile' },
          { type: 'pattern', message: 'Please enter a valid url' },
        ],
      },
      {
        label: 'Industry',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'industry',
        name: 'industry',
        placeholder: 'Industry',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        min: 3,
        max: 100,
      },
      {
        label: 'Number of Employee',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'employee',
        name: 'total_employees',
        placeholder: 'No. of Employee',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
      },
    ],
  },
  {
    groupLabel: 'Company Address',
    groupLabelClass: 'fieldset-label',
    key: 'address',
    name: 'address',
    groupClass: 'form-fieldset',
    inputs: [
      {
        label: 'Address',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'address',
        name: 'address',
        placeholder: 'Address',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        min: 3,
        max: 100,
        errors: [{ type: 'required', message: 'Please enter the company address' }],
      },
      {
        label: 'City',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'city',
        name: 'city',
        placeholder: 'City',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        min: 3,
        max: 100,
        errors: [{ type: 'required', message: 'Please enter the city' }],
      },
      {
        label: 'Zip Code',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'zipcode',
        name: 'zipcode',
        placeholder: 'Zip Code',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        pattern: Validation.numberOnly,
        min: 3,
        max: 6,
        errors: [
          {
            type: 'required',
            message: 'Please enter the zipcode',
            type: 'pattern',
            message: 'Please enter a valid zipcode',
          },
        ],
      },
      {
        label: 'State/Province/Region',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'state',
        name: 'state',
        placeholder: 'State/Province/Region',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        min: 3,
        max: 100,
        errors: [
          {
            type: 'required',
            message: 'Please enter the state/province/region',
          },
        ],
      },
      {
        label: 'Country',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'country',
        name: 'country',
        placeholder: 'Country',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        min: 3,
        max: 100,
        errors: [
          {
            type: 'required',
            message: 'Please enter the country name',
          },
        ],
      },
      {
        label: 'Timezone',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'timezone',
        name: 'timezone',
        placeholder: 'Timezone',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'select',
        fieldClass: 'multiselect',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        size: 'small',
      },
    ],
  },
  {
    groupLabel: 'Billing Address',
    groupLabelClass: 'fieldset-label',
    key: 'billing',
    groupClass: 'form-fieldset',
    inputs: [
      {
        label: 'Billing Email',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'billing_email',
        name: 'billing_email',
        placeholder: 'Billing Email',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        pattern: Validation.email,
        min: 3,
        max: 100,
        errors: [
          {
            type: 'required',
            message: 'Please enter the country name',
            type: 'pattern',
            message: 'Please enter a valid email'
          },
        ],
      },
      {
        label: 'Address',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'address',
        name: 'billing_address',
        placeholder: 'Address',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        min: 3,
        max: 100,
        errors: [
          {
            type: 'required',
            message: 'Please enter the billing address',
          },
        ],
      },
      {
        label: 'City',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'billing_city',
        name: 'billing_city',
        placeholder: 'City',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        min: 3,
        max: 100,
        errors: [
          {
            type: 'required',
            message: 'Please enter the city',
          },
        ],
      },
      {
        label: 'Zip Code',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'billing_zipcode',
        name: 'billing_zipcode',
        placeholder: 'Zip Code',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        min: 3,
        max: 6,
        pattern: Validation.numberOnly,
        errors: [
          {
            type: 'required',
            message: 'Please enter the zipcode',
            type: 'pattern',
            message: 'Please enter a valid zipcode',
          },
        ],
      },
      {
        label: 'State/Province/Region',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'state',
        name: 'billing_state',
        placeholder: 'State/Province/Region',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        min: 3,
        max: 100,
        errors: [{ type: 'required', message: 'Please enter the state/province/region' }],
      },
      {
        label: 'Country',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'billing_country',
        name: 'billing_country',
        placeholder: 'Country',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        min: 3,
        max: 100,
        errors: [{ type: 'required', message: 'Please enter the country name' }],
      },
    ],
  },
];

// Client Data
export const Clients = [
  { label: 'Client 1', name: 'Client 1', key: 'client1', value: 'Client 1' },
  { label: 'Client 2', name: 'Client 2', key: 'client2', value: 'Client 2' },
  { label: 'Client 3', name: 'Client 3', key: 'client3', value: 'Client 3' },
  { label: 'Client 4', name: 'Client 4', key: 'client4', value: 'Client 4' },
  { label: 'Client 5', name: 'Client 5', key: 'client5', value: 'Client 5' },
];
